import { ImgixPicture, ImgixFit } from '../../components/ImgixPicture';

import styles from './HeroSlice.css';

import type { HeroSliceType } from './types';
import type { ResponsiveSources } from '../../components/ImgixPicture';

export interface HeroSliceProps {
  slice: HeroSliceType;
}

const DEFAULT_XS_WIDTH = 375;
const DEFAULT_XS_HEIGHT = 424;
const DEFAULT_MD_WIDTH = 1452;
const DEFAULT_MD_HEIGHT = 538;

export function HeroSlice({ slice }: HeroSliceProps) {
  const { image } = slice.primary;

  const hasDesktop = Boolean(image?.desktop?.url);
  const hasMobile = Boolean(image?.mobile?.url);

  if (!(hasDesktop || hasMobile)) {
    return null;
  }

  const src: ResponsiveSources = {
    xs: hasMobile
      ? {
          url: image.mobile.url,
          transformations: {
            fit: ImgixFit.crop,
            w: image.mobile.dimensions.width ?? DEFAULT_XS_WIDTH,
            h: image.mobile.dimensions.height ?? DEFAULT_XS_HEIGHT,
          },
        }
      : undefined,
    md: hasDesktop
      ? {
          url: image.desktop.url,
          transformations: {
            fit: ImgixFit.crop,
            w: image.desktop.dimensions.width ?? DEFAULT_MD_WIDTH,
            h: image.desktop.dimensions.height ?? DEFAULT_MD_HEIGHT,
          },
        }
      : undefined,
  };

  return (
    <div className={styles.container}>
      <ImgixPicture src={src} className={styles.img} alt={image.alt} />
    </div>
  );
}
